import { render, staticRenderFns } from "./SettingUp.vue?vue&type=template&id=1451736b&scoped=true"
import script from "./SettingUp.vue?vue&type=script&lang=js"
export * from "./SettingUp.vue?vue&type=script&lang=js"
import style0 from "./SettingUp.vue?vue&type=style&index=0&id=1451736b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451736b",
  null
  
)

export default component.exports